// import React from "react";
//
// export const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
//     {children, className, ...props }
// ) => {
//     return <div style={{ ...props }}>
//         {children}
//         </div>;
// };
//
// export const CardContent: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
//     { children, className, ...props }
// ) => {
//     return <div className={`flex flex-col ${className || ""}`} {...props}>
//         {children}
//     </div>;
// };


import React from "react";

export const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
    {children, className, ...props }
) => {
    return <div className={`rounded-xl shadow p-2 ${className || ""}`} {...props}>
        {children}
    </div>;
};

export const CardContent: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
    { children, className, ...props }
) => {
    return <div className={`flex flex-col ${className || ""}`} {...props}>
        {children}
    </div>;
};
